import { useTranslations } from 'next-intl';
import { BaseLineShare2 } from '@/app/components/icons/BaseLineShare2';
import { TRACE_EVENT_ID, TRACE_EVENT_NAME } from '@/app/constants';
import { useCopy } from '@/app/hooks';
import { CommunityEnum } from '@/app/types';
import { reportEvent } from '@/app/utils';
import { generateCommunityShareUrl } from '@/app/utils/client';
import { usePathname } from '@/i18n/routing';

interface Props {
  id: string;
  type: CommunityEnum;
  isActivity?: boolean;
}

export const CommunityShareBtn = ({ id, type, isActivity }: Props) => {
  const t = useTranslations();
  const { copy } = useCopy();
  const pathname = usePathname();
  const handleShareClick = () => {
    const url = generateCommunityShareUrl({ id, isActivity });

    reportEvent(TRACE_EVENT_NAME[type], {
      [TRACE_EVENT_ID[type]]: id,
      interaction_position: pathname,
      interaction_type: 'share',
      content_type: type === CommunityEnum.ImageAsset ? 'image' : 'video',
    });
    copy(url, {
      copySuccessMessage: t('create.share.description'),
    });
  };

  return (
    <div
      className="skip-login-check flex aspect-square size-10 h-full cursor-pointer items-center justify-center rounded-10 bg-white/10 text-lg backdrop-blur-lg hover:bg-system-white/20 md:size-12 md:rounded-12 md:text-2xl"
      onClick={handleShareClick}
    >
      <BaseLineShare2 />
    </div>
  );
};
